
import React from 'react';
import { Navigate } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import { UserTicketsPage } from '@/components/tickets/UserTicketsPage';
import { useAuthSession } from '@/hooks/useAuthSession';

export default function Support() {
  const { isAuthenticated, isLoading } = useAuthSession();

  if (!isLoading && !isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <MainLayout>
      <div className="container max-w-7xl mx-auto px-4 py-8">
        <UserTicketsPage />
      </div>
    </MainLayout>
  );
}
